<template>
  <NuxtLayout>
    <NuxtPage />
    <ModalRoot />
  </NuxtLayout>
</template>

<script setup lang="ts">
import ModalRoot from './plugins/modal/ModalRoot.vue';
</script>
